import { createContext } from 'react'
import { MachineShape, UserShape } from '../api/api_data_types'

export type JobPlanningsFilterType = {
  no: string[]
  job_task_no: string[]
  start_date?: string
  end_date?: string
  production_place?: string
}

export type SavedFilterType = {
  id: string
  name: string
  default: boolean
  filter: any
}

export type CurrentUserType = {
  id: number
  name: string
  username: string
  email: string
  saved_filters: Array<SavedFilterType>
  saved_production_filters: Array<SavedFilterType>
  available_worktypes: [string, number][]
  available_warehouses: WarehouseType[]
  available_machines: MachineShape[]
  allow_to_add_job_plannings: boolean
  allow_time_registrations_for_partners: boolean
  allow_two_minutes_time_registrations: boolean
  is_department_manager: boolean
  hide_machines: boolean
  hide_items: boolean
  hide_packagings: boolean
  hide_shipments: boolean
  hide_purchases: boolean
  hide_consumption_list?: boolean
  hide_picking_list?: boolean
  hide_scan?: boolean
  areas: string[]
  default_machines?: MachineShape[]
  default_worktype_id?: number
  car_registration?: string
  weeklist_default_department_ids?: string[]
  combined_available_status_codes?: Array<{ id: string; code: string }>
  preferences?: any
  complete_stage_permission?: string
  managed_usernames?: string[]
  coworkers_usernames?: string[]
}

export type WarehouseType = {
  id: number
  batch_name: string
  title: string
  location_code: string
  location_code_title: string
  stock_level_code: string
  is_default_for_west: boolean
  is_default_for_east: boolean
}

export type CommonContextType = {
  // User-related
  currentUser: CurrentUserType
  updateCurrentUser?: (currentUser: CurrentUserType) => void

  // Lists and dictionaries
  availableWarehouses?: WarehouseType[]
  allPartners?: any[]
  availableUsers?: UserShape[]
  availableApprovalFormTemplates?: any[]
  availableAreas?: string[]
  availableDepartments?: any[]
  availableWorktypes?: any[]
  availableWorkcards?: any[]
  availablePartners?: any[]
  availableTasks?: any[]

  // URLs
  smProjectUrl?: string
  createSMProjectUrl?: string
  dynamicsnavPrefix?: string
}

const CommonContext = createContext<CommonContextType>(null)

export default CommonContext
